export default __webpack_public_path__ + "galaxies.mp3";